import type {ReactAction} from '@netx/core/bootstrap';
import {faExpandArrowsAlt} from '@fortawesome/pro-solid-svg-icons';
import {canManageCurrentCartRelationships} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

/**
 * Delink cart asset relationships
 * @param params
 * @returns Action
 */
export const cartActionManageRelationshipsDelink = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-manage-relationships-delink',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.RELATIONSHIPS_DELINK),
	enableTest: canManageCurrentCartRelationships,
	icon: faExpandArrowsAlt,
	get label() {
		return CART_CURRENT_ACTION_LABELS.RELATIONSHIPS_DELINK;
	},
	...params,
});

export default cartActionManageRelationshipsDelink;
